export default __webpack_public_path__ + "static/media/vatican_news.2b6d3af4.svg";